import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

export default function VideoDownloadButton({ url }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!url) return;
    setIsDownloading(true);
    try {
      const blob = await (await fetch(url)).blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "video.mp4";
      a.click();

      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (err) {
      console.error("Download error:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={isDownloading}
      className={`ml-2 px-3 py-1 rounded text-sm flex items-center gap-2 ${
        isDownloading
          ? "text-gray-400 cursor-not-allowed"
          : "text-gray-600 hover:text-black"
      } bg-transparent`}
    >
      {isDownloading ? "Downloading..." : "Download"}
      <FontAwesomeIcon icon={faDownload} className="text-gray-500" />
    </button>
  );
}
